module.exports = __webpack_public_path__ + "static/media/section-3-2@3x.5c0864e9.png";